import { render, staticRenderFns } from "./EditarCupDialogComponent.vue?vue&type=template&id=bed33eb4"
import script from "./EditarCupDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarCupDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports